var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'text-field': true,
  'text-field-with-icon': _vm.$slots.icon,
  'text-field-with-errors': _vm.errored,
  'text-field-non-empty': _vm.value && _vm.value.length > 0,
  'text-field-disabled': _vm.disabled
}},[_c('div',{staticClass:"text-field-content"},[_c('input',_vm._b({staticClass:"text-field-input",attrs:{"type":_vm.type,"name":_vm.name,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"id":("textfield-" + _vm.name)},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},'input',_vm.inputConfig,false)),(_vm.$slots.icon)?_c('label',{staticClass:"text-field-icon",attrs:{"for":("textfield-" + _vm.name)}},[_vm._t("icon")],2):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }